/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link } from 'react-router-dom'

const MyCoursesNoCourse: FC = () => {
    const intl = useIntl()

    return (
        <>
            <div className='row landing noCourse'>
                <div className='col-lg-7 d-flex flex-column justify-content-center'>
                    <h1>
                    {intl.formatMessage({ id: 'POPLEADS.NO_COURSE' })}
                    </h1>
                    <p>
                    {intl.formatMessage({ id: 'POPLEADS.NO_COURSE_INFO' })}
                      </p>
                    <Link to="/"><button>{intl.formatMessage({ id: 'POPLEADS.NO_COURSE_INFO_BUTTON' })}</button></Link>
                </div>
                <div className='col-lg-5'>
                    <img
                        id='illusRight'
                        alt=''
                        src={toAbsoluteUrl('/media/illustrations/illustration_1.png')}
                    />
                </div>
            </div>
        </>
    )
}

export { MyCoursesNoCourse }
